import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-page-spinner',
  templateUrl: './page-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule]
})
export class PageSpinnerComponent {
  @Input() loaderIcon: string = 'ball-scale-multiple';
  @Input() showLoaderMessage: boolean = false;
  @Input() loaderText: string = 'Loading...';
}
